import i18n from "../../../i18n";import { Trans } from "react-i18next";const pagerBtn =
"h-8 w-8 grid place-items-center rounded-lg border border-[var(--color-text-border)] text-[var(--color-text-secondary)] hover:bg-[var(--color-workspace)]/40 hover:text-[var(--color-primary)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

/** Shared presentational pagination bar for Leave Management tables. */
export function TablePagination({ page, totalPages, totalItems, pageSize, onPageChange }) {
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-t border-[var(--color-text-border)]/60 text-xs text-[var(--color-text-secondary)]">
      <span>
        <Trans i18nKey="pagination.showing" /> {start}-{end} <Trans i18nKey="common.of" /> {totalItems}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          aria-label={i18n.t("pagination.previousPage")}
          className={pagerBtn}>
          
          ‹
        </button>
        <span className="px-2 text-xs font-semibold text-foreground">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          aria-label={i18n.t("pagination.nextPage")}
          className={pagerBtn}>
          
          ›
        </button>
      </div>
    </div>);

}
